<template>
    <div v-if="imageFw.length > 0" class="detail-list">
        <p style="width: 60px" class="tr">{{ title }}：</p>
        <div style="flex: 1" :class="{ mainImageStyle: title === '主图' }">
            <div v-for="(item, index) in imgList" :key="index" class="detail-list-item">
                <el-popover placement="right" width="400" trigger="hover" :disabled="item.Url === ''">
                    <div
                        class="modify-image-large-img"
                        :style="{ backgroundImage: `url(${item.Url === '' ? item.path : item.Url})` }"
                    ></div>
                    <div
                        slot="reference"
                        class="detail-img"
                        :style="{ backgroundImage: `url(${item.Url === '' ? item.path : item.Url})` }"
                        @click="$emit('scroll2Img', item.Url === '' ? item.path : item.Url)"
                    >
                        <div v-if="item.ignore === 0 || item.Url === item.path" class="tag red">未处理</div>
                        <div v-if="item.ignore !== 0 || item.Url !== item.path" class="tag blue">已更换</div>
                        <div
                            v-if="
                                (item.ignore !== 0 && item.fontJudge == '是') ||
                                (item.ignore !== 0 && item.word != '无检测出违禁词')
                            "
                            class="tag blue"
                        >
                            已忽略
                        </div>
                    </div>
                </el-popover>
                <div v-show="item.Url === ''" class="detail-delete-tag">
                    <p class="tag">已删除</p>
                </div>
                <div class="detail-operation dfcjsb ml10 curp">
                    <i class="el-icon-view" title="查看检测结果" @click="$emit('lookCheckResult', item)"></i>
                    <!-- <img
                        src="../../../assets/img/change_con.jpg"
                        alt=""
                        title="更换图片"
                        @click="$emit('changeImg', item)"
                    /> -->
                    <i class="el-icon-delete" title="删除图片" @click="$emit('delImage', item)"></i>
                    <img
                        src="../../../assets/img/for_con.jpg"
                        alt=""
                        title="忽略"
                        @click="$emit('ignoreTips', item, title === '主图')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ModifyImageAsideBar',
    props: {
        imageFw: {
            type: Array,
            default() {
                return [];
            },
        },
        images: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            title: '详情图',
        };
    },
    computed: {
        imgList({ images }) {
            const arr = images.filter((v) => v.name === this.title && v.ignore != 1);
            return arr;
        },
    },
    methods: {
        show(title) {
            this.title = title;
        },
    },
};
</script>
<style lang="scss" scoped>
.detail-list {
    height: 100%;

    display: flex;
    align-items: flex-start;
    .mainImageStyle {
        display: flex;
        align-items: center;
        .detail-list-item {
            & + .detail-list-item {
                margin: 0;
                margin-left: 40px;
            }
        }
    }
    .detail-list-item {
        display: flex;
        position: relative;
        & + .detail-list-item {
            margin-top: 10px;
        }
        .detail-img {
            width: 100px;
            height: 100px;
            border: 1px solid #dddddd;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
            background-color: #fff;
            position: relative;
            overflow: hidden;
            .tag {
                transform: rotate(-45deg);
                left: -20px;
                top: 14px;
                position: absolute;
                height: 20px;
                line-height: 20px;
                text-align: center;
                width: 86px;
                color: #fff;
                &.blue {
                    background-color: #3a8cee;
                }
                &.red {
                    background-color: #fc214a;
                }
            }
        }
        .detail-delete-tag {
            width: 100px;
            height: 100px;
            overflow: hidden;
            background-color: rgba(0, 0, 0, 0.6);
            position: absolute;
            top: 0;
            left: 0;
            .tag {
                transform: rotate(-45deg);
                left: -18px;
                top: 14px;
                position: absolute;
                height: 20px;
                line-height: 20px;
                text-align: center;
                width: 86px;
                color: #fff;
                background-color: #3a8cee;
            }
        }
        .detail-operation {
            flex-direction: column;
        }
    }
}
.modify-image-large-img {
    width: 380px;
    height: 380px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #fff;
}
</style>
